
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.746 4.63a.767.767 0 00-.736 0L5.535 8.16l6.475 3.532c.23.125.507.125.736 0L19.22 8.16l-6.475-3.532zm-1.471-1.348a2.302 2.302 0 012.206 0l6.474 3.53c1.068.583 1.068 2.115 0 2.697l-1.047.572 1.047.57c1.068.583 1.068 2.115 0 2.697l-1.047.571 1.047.572c1.068.582 1.068 2.114 0 2.696l-6.474 3.531a2.302 2.302 0 01-2.206 0L4.8 17.188c-1.067-.583-1.067-2.115 0-2.697l1.048-.572-1.048-.57c-1.067-.583-1.067-2.115 0-2.697l1.048-.571L4.8 9.509c-1.067-.582-1.067-2.114 0-2.696l6.475-3.531zM7.45 10.955L5.535 12l6.475 3.532c.23.125.507.125.736 0L19.22 12l-1.916-1.045-3.824 2.085a2.303 2.303 0 01-2.206 0L7.45 10.955zm0 3.839l-1.916 1.045 6.475 3.532c.23.125.507.125.736 0l6.475-3.532-1.916-1.045-3.824 2.085a2.303 2.303 0 01-2.206 0L7.45 14.794z"}})])
          )
        }
      }
    